module.exports = __webpack_public_path__ + "./docs/img/icon-class.e483d5c5a22a3f521f79653c4f5aafdc.svg";